import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ecf7d664&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ecf7d664&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf7d664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecf7d664')) {
      api.createRecord('ecf7d664', component.options)
    } else {
      api.reload('ecf7d664', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ecf7d664&scoped=true", function () {
      api.rerender('ecf7d664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderViewConfig/index.vue"
export default component.exports